export interface CustomValueItem {
  /** Human-readable label shown in the picker, e.g. "Full Name". */
  label: string;
  /** The token inserted into the field, e.g. "{{contact.name}}". */
  value: string;
}

export interface CustomValueCategory {
  /** Stable key for the category. */
  key: string;
  /** Human-readable label shown in the category list, e.g. "Contact". */
  label: string;
  /** Custom values belonging to this category. */
  items: CustomValueItem[];
}

/**
 * GHL-style custom values, grouped by category.
 *
 * We're starting with the Contact category only; additional categories
 * (Company, User, Message, ...) can be appended here later without any
 * changes to the picker UI.
 */
export const CUSTOM_VALUE_CATEGORIES: CustomValueCategory[] = [
  {
    key: "contact",
    label: "Contact",
    items: [
      { label: "Full Name", value: "{{contact.name}}" },
      { label: "First Name", value: "{{contact.first_name}}" },
      { label: "Last Name", value: "{{contact.last_name}}" },
      { label: "Email", value: "{{contact.email}}" },
      { label: "Phone", value: "{{contact.phone}}" },
      { label: "Phone (raw format)", value: "{{contact.phone_raw}}" },
      { label: "Company Name", value: "{{contact.company_name}}" },
      { label: "Address 1", value: "{{contact.address1}}" },
      { label: "City", value: "{{contact.city}}" },
      { label: "State", value: "{{contact.state}}" },
      { label: "Country", value: "{{contact.country}}" },
      { label: "Postal Code", value: "{{contact.postal_code}}" },
      { label: "Date of birth", value: "{{contact.date_of_birth}}" },
      { label: "Source", value: "{{contact.source}}" },
      { label: "Website", value: "{{contact.website}}" },
      { label: "ID", value: "{{contact.id}}" },
    ],
  },
  {
    key: "company",
    label: "Company",
    items: [
      { label: "Name", value: "{{business.name}}" },
      { label: "Email", value: "{{business.email}}" },
      { label: "Phone", value: "{{business.phone}}" },
      { label: "Website", value: "{{business.website}}" },
      { label: "Address", value: "{{business.address}}" },
      { label: "City", value: "{{business.city}}" },
      { label: "State", value: "{{business.state}}" },
      { label: "Country", value: "{{business.country}}" },
      { label: "Postal Code", value: "{{business.postalCode}}" },
      { label: "Description", value: "{{business.description}}" },
    ],
  },
  {
    key: "user",
    label: "User",
    items: [
      { label: "Full Name", value: "{{user.name}}" },
      { label: "First Name", value: "{{user.first_name}}" },
      { label: "First Name (lower case)", value: "{{user.first_name_lower_case}}" },
      { label: "Last Name", value: "{{user.last_name}}" },
      { label: "Last Name (lower case)", value: "{{user.last_name_lower_case}}" },
      { label: "Email", value: "{{user.email}}" },
      { label: "Phone", value: "{{user.phone}}" },
      { label: "Signature", value: "{{user.email_signature}}" },
      { label: "Calendar Link", value: "{{user.calendar_link}}" },
      { label: "Twilio Phone", value: "{{user.twilio_phone_number}}" },
      { label: "Twilio Phone (raw format)", value: "{{user.twilio_phone_number_raw}}" },
    ],
  },
  {
    key: "message",
    label: "Message",
    items: [{ label: "Message Body", value: "{{message.body}}" }],
  },
];
